import { render, staticRenderFns } from "./MicrodataTable.vue?vue&type=template&id=f4748d08&scoped=true&"
import script from "./MicrodataTable.vue?vue&type=script&lang=js&"
export * from "./MicrodataTable.vue?vue&type=script&lang=js&"
import style0 from "./MicrodataTable.vue?vue&type=style&index=0&id=f4748d08&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4748d08",
  null
  
)

export default component.exports